module.exports = __webpack_public_path__ + "img/loading.166881e6.gif";